import { useState } from "react";
import { Field } from "formik";
import { Grid2 } from "@mui/material";
import { useAdminCity, useAdminCountry, useAdminState, useClusterByZone } from "../../assets/api/useAdminApi";
import { IdAutoCompleteField } from "./formfields/IdAutoCompleteField";
import { useZoneList } from "../../assets/api/useMarketingExecutive";
import { AutoCompleteField } from "./formfields/AutoCompleteField";

export const LocationFilterFields = ({
    countryField = "country",
    stateField = "state",
    cityField = "city",
    zoneField = "zone",
    clusterField = "cluster",
    Input_Width = 12,
    isStoredId = true,

}) => {
    
    const [searchCity, setSearchCity] = useState("")
    const [searchState, setSearchState] = useState("")
    const [countryId, setCountryId] = useState();
    const [stateId, setStateId] = useState();
    const [cityId, setCityId] = useState();
    const [zoneId, setZoneId] = useState();

    const { data: countryList } = useAdminCountry();
    const { data: stateList } = useAdminState({ country_id: countryId, search: searchState });
    const { data: cityList } = useAdminCity({
        country_id: countryId,
        state_id: stateId,
        search: searchCity
    });

    const { data: ClusterList, isLoading: isClusterLoading } = useClusterByZone({ zone_id: zoneId })

    const { data: zoneList } = useZoneList({ city_id: cityId });

    const countryOption =
        countryList?.data?.map((item) => ({
            id: item.id,
            label: item.country_name,
            value: item.country_name,
        })) || [];

    const stateOption =
        stateList?.data?.map((item) => ({
            id: item.id,
            label: item.state_name,
            value: item.state_name,
        })) || [];

    const cityOption =
        cityList?.data?.map((item) => ({
            id: item.id,
            label: item.city_name,
            value: item.city_name,
        })) || [];

    const zoneOption =
        zoneList?.data?.map((item) => ({
            id: item.id,
            label: item.zone_name,
            value: item.zone_name,
        })) || [];

    const clusterOption = ClusterList?.map((item, index) => ({
        id: item?.id,
        value: item?.cluster_name,
        label: item?.cluster_name
    }))

    return (
        <>
            <Grid2 size={Input_Width}>
                <Field
                    name={countryField}
                    component={isStoredId ? IdAutoCompleteField : AutoCompleteField}
                    options={countryOption}
                    label="Country"
                    onValueChange={(val) => {
                        setCountryId(val?.id);
                        setStateId(undefined);
                        setCityId(undefined);
                    }}

                />
            </Grid2>

            <Grid2 size={Input_Width}>
                <Field
                    name={stateField}
                    component={isStoredId ? IdAutoCompleteField : AutoCompleteField}
                    options={stateOption}
                    label="State"
                    onValueChange={(val) => {
                        setStateId(val?.id);
                        setCityId(undefined);
                    }}
                    onSearchChange={(val) => {
                        setSearchState(val)
                    }}
                />
            </Grid2>

            <Grid2 size={Input_Width}>
                <Field
                    name={cityField}
                    component={isStoredId ? IdAutoCompleteField : AutoCompleteField}
                    options={cityOption}
                    label="City"
                    onValueChange={(val) => {
                        setCityId(val?.id);
                    }}
                    onSearchChange={(val) => {
                        setSearchCity(val)
                    }}
                />
            </Grid2>
            {
                zoneField &&
                <Grid2 size={Input_Width}>
                    <Field
                        name={zoneField}
                        component={IdAutoCompleteField}
                        options={zoneOption}
                        label="Zone"
                        onValueChange={(val) => {
                            setZoneId(val?.id);
                        }}
                    />
                </Grid2>
            }

            {
                clusterField &&
                <Grid2 size={Input_Width}>
                    <Field
                        name={clusterField}
                        component={IdAutoCompleteField}
                        options={clusterOption}
                        label="Cluster"
                        isLoading={isClusterLoading}
                    />
                </Grid2>
            }
        </>
    );
};
